import { Pencil, Trash2 } from "lucide-react";
import { euro, imgUrl } from "@/lib/api";

export function ProductsTable({ products, onEdit, onDelete }) {
  return (
    <div className="overflow-x-auto rounded-sm border border-[var(--line)]">
      <table data-testid="admin-products-table" className="w-full min-w-[720px] text-sm">
        <thead className="bg-[var(--ink-2)] text-left text-[11px] uppercase tracking-[0.2em] text-[var(--muted)]">
          <tr><th className="p-4">Produit</th><th className="p-4">Type</th><th className="p-4">Gamme</th><th className="p-4">Prix</th><th className="p-4">Statut</th><th className="p-4" /></tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <tr key={p.id} data-testid={`admin-product-row-${p.slug}`} className="border-t border-[var(--line)]">
              <td className="p-4">
                <div className="flex items-center gap-3">
                  <img src={imgUrl(p.image)} alt="" className="h-12 w-12 rounded-sm object-cover" />
                  <span className="font-display text-base">{p.name}</span>
                </div>
              </td>
              <td className="p-4 text-[var(--muted)]">{p.type === "pack" ? "Pack" : "Unité"}</td>
              <td className="p-4 text-[var(--muted)]">{p.category}</td>
              <td className="p-4 text-[var(--gold-soft)]">{euro(p.price)}</td>
              <td className="p-4">{p.active ? <span className="text-emerald-400">En ligne</span> : <span className="text-[var(--muted)]">Masqué</span>}</td>
              <td className="p-4">
                <div className="flex justify-end gap-2">
                  <button data-testid={`admin-edit-${p.slug}`} onClick={() => onEdit(p)} className="rounded-full border border-[var(--line)] p-2 hover:border-[var(--gold)]"><Pencil className="h-4 w-4" /></button>
                  <button data-testid={`admin-delete-${p.slug}`} onClick={() => onDelete(p)} className="rounded-full border border-[var(--line)] p-2 hover:border-red-400 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
